import { createTheme } from '@mui/material';

// Создаем унифицированную тему для всего проекта
export const appTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#1a237e',
      light: '#534bae',
      dark: '#000051',
    },
    secondary: {
      main: '#90a4ae',
      light: '#c1d5e0',
      dark: '#62757f',
    },
    background: {
      default: '#071124',
      paper: '#162238',
    },
    text: {
      primary: '#ffffff',
      secondary: '#90a4ae',
    },
    error: {
      main: '#f44336',
      light: '#ef5350',
      dark: '#d32f2f',
    },
    warning: {
      main: '#ff9800',
      light: '#ffb74d',
      dark: '#f57c00',
    },
    success: {
      main: '#4caf50',
      light: '#81c784',
      dark: '#388e3c',
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#162238',
          color: '#ffffff',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#071124',
          borderBottom: '1px solid #1a237e',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          textTransform: 'none',
          fontWeight: 600,
          transition: 'all 0.2s ease-in-out',
          // Hover only on a real pointer. On phones :hover sticks and paints
          // disabled command buttons as if they were pressable.
          '@media (hover: hover) and (pointer: fine)': {
            '&:hover:not(.Mui-disabled)': {
              transform: 'scale(1.02)',
            },
          },
          '&.Mui-disabled, &.Mui-disabled:hover, &.Mui-disabled:active': {
            pointerEvents: 'none',
            boxShadow: 'none',
            transform: 'none',
            color: '#78909c',
            WebkitTextFillColor: '#78909c',
          },
        },
        contained: {
          backgroundColor: '#1a237e',
          '@media (hover: hover) and (pointer: fine)': {
            '&:hover:not(.Mui-disabled)': {
              backgroundColor: '#000051',
            },
          },
          '&.Mui-disabled, &.Mui-disabled:hover, &.Mui-disabled:active': {
            backgroundColor: 'rgba(144, 164, 174, 0.28)',
            color: '#78909c',
            WebkitTextFillColor: '#78909c',
            boxShadow: 'none',
          },
        },
        outlined: {
          borderColor: '#1a237e',
          color: '#1a237e',
          '@media (hover: hover) and (pointer: fine)': {
            '&:hover:not(.Mui-disabled)': {
              borderColor: '#000051',
              backgroundColor: 'rgba(26, 35, 126, 0.1)',
            },
          },
          '&.Mui-disabled, &.Mui-disabled:hover, &.Mui-disabled:active': {
            borderColor: 'rgba(120, 144, 156, 0.55)',
            color: '#78909c',
            WebkitTextFillColor: '#78909c',
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#263238',
            },
            '&:hover fieldset': {
              borderColor: '#90a4ae',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#1a237e',
            },
          },
          '& .MuiInputLabel-root': {
            color: '#90a4ae',
          },
          '& .MuiOutlinedInput-input': {
            color: '#ffffff',
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          margin: '4px 0',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: '#1a237e',
            transform: 'scale(1.02)',
          },
          '&.Mui-selected': {
            backgroundColor: '#1a237e',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#000051',
            },
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          '&:hover': {
            backgroundColor: '#1a237e',
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: '#90a4ae',
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '0.9rem',
          '&.Mui-selected': {
            color: '#ffffff',
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          '& .MuiTabs-indicator': {
            backgroundColor: '#1a237e',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          color: '#ffffff',
          '& .MuiSvgIcon-root': {
            color: '#90a4ae',
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: '#1a237e',
          },
          '&.Mui-selected': {
            backgroundColor: '#1a237e',
            '&:hover': {
              backgroundColor: '#000051',
            },
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: '#1a237e',
          color: '#ffffff',
          '&.MuiChip-outlined': {
            borderColor: '#1a237e',
            color: '#1a237e',
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#162238',
          borderRight: '1px solid #1a237e',
        },
      },
    },
  },
  shape: {
    borderRadius: 8,
  },
  spacing: 8,
});

export default appTheme; 